import React, {createContext, useContext} from 'react';
import useRoleManagement from './useRoleManagement';

interface RoleContextType {
    roles: string[];
    hasRole: (role: string) => boolean;
}

const RoleContext = createContext<RoleContextType>({
    roles: [],
    hasRole: () => false,
});

export function RoleProvider({children}: { children: React.ReactNode }) {
    const roleManagement = useRoleManagement();
    return (
        <RoleContext.Provider value={roleManagement}>
            {children}
        </RoleContext.Provider>
    );
}

export function useRoles() {
    return useContext(RoleContext);
}
